function serialize(form) {
  var serialized = [];

  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
      continue;
    }

    if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');
}

export default function onSubmit(event) {
  var xhr = new XMLHttpRequest();
  var form = event.target;
  var data = serialize(form);
  xhr.open('POST', event.target.action, true);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200) {
        if (xhr.responseText.trim() === 'success') {
          form.reset();
          return alert('E-mail byl úspěšně odeslán.');
        }
      }

      return alert('Něco se pokazilo, zkuste to znovu.');
    }
  };

  xhr.send(data);
  event.preventDefault();
}